'use client';

import { cn } from '@/shared/utils/tw';
import { WarningIcon } from './icons/warning-icon';
import type { Toast } from '../types/toast-types';

interface ToastErrorProps {
  toast: Toast;
}

/**
 * Toast-Error: 에러 토스트 (빨간색 아이콘 포함)
 */
export const ToastError = ({ toast }: ToastErrorProps) => (
  <div
    className={cn(
      'bg-[rgba(255,255,255,0.2)]',
      'backdrop-blur-[20px]',
      '[-webkit-backdrop-filter:blur(20px)]',
      'rounded-full',
      'px-[18px] py-2',
      'flex items-center gap-1',
      'font-pretendard text-sm font-normal text-white',
      'pointer-events-auto',
      toast.isExiting ? 'animate-toast-exit' : 'animate-toast-enter'
    )}
  >
    <WarningIcon className="w-[18px] h-[18px] text-[#F5363C] flex-shrink-0" />
    <span>{toast.message}</span>
  </div>
);
